export const ACTIVATION_CODE_LENGTH = 6

const CODE_PATTERN = /^[A-Z0-9]{6}$/

/** Trim, uppercase, buang non-alfanumerik; panjang tepat 6 (format HO). */
export function normalizeActivationCodeInput(raw: string): string {
  return raw
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, ACTIVATION_CODE_LENGTH)
}

export function isValidActivationCode(code: string): boolean {
  return CODE_PATTERN.test(code)
}
